"use client";

import PageLayout from "../PageLayout"
import PageHead from "../PageHead"
import {
  PageLayout as PageLayoutSanity,
  SiteConfig,
} from "@/contents/sanityTypes"
import { LocaleProvider } from "@/modules/i18n/context";
import { Locale, isValidLocale } from "@/lib/i18n";

export interface PageWrapperProps {
  settings: SiteConfig
  layout?: PageLayoutSanity
  children: any
  locale: string
  documentId?: string
}

const PageWrapper = ({
  settings,
  layout,
  children,
  locale,
  documentId,
}: PageWrapperProps) => {
  // Validate locale
  const validatedLocale = isValidLocale(locale) ? locale as Locale : "it" as Locale;
  
  return (
    <LocaleProvider locale={validatedLocale}>
      <PageLayout settings={settings} layout={layout} locale={locale}>
        <PageHead settings={settings} />
        {children}
      </PageLayout>
    </LocaleProvider>
  )
}

export default PageWrapper
